import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const STATUS = {
  pendiente: { label: "Pendiente", color: "#64748B", bg: "bg-slate-100", text: "text-slate-700" },
  en_revision: { label: "En revisión", color: "#8B5CF6", bg: "bg-violet-100", text: "text-violet-700" },
  en_proceso: { label: "En proceso", color: "#3B82F6", bg: "bg-blue-100", text: "text-blue-700" },
  cumplido: { label: "Cumplido", color: "#10B981", bg: "bg-emerald-100", text: "text-emerald-700" },
  detenido: { label: "Detenido", color: "#F59E0B", bg: "bg-amber-100", text: "text-amber-800" },
};

export const PRIORITY = {
  alta: { label: "Alta", color: "#EE1C25", bg: "bg-red-100", text: "text-red-700" },
  media: { label: "Media", color: "#F59E0B", bg: "bg-amber-100", text: "text-amber-800" },
  baja: { label: "Baja", color: "#10B981", bg: "bg-emerald-100", text: "text-emerald-700" },
};

export const PROJECT_STATUS = {
  planificacion: { label: "Planificación", bg: "bg-slate-100", text: "text-slate-700" },
  en_ejecucion: { label: "En ejecución", bg: "bg-blue-100", text: "text-blue-700" },
  en_pausa: { label: "En pausa", bg: "bg-amber-100", text: "text-amber-800" },
  finalizado: { label: "Finalizado", bg: "bg-emerald-100", text: "text-emerald-700" },
};

export const ROLES = {
  administrador: "Administrador",
  coordinador: "Coordinador",
  colaborador: "Colaborador",
  lectura: "Modo lectura",
};

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    // Date-only (YYYY-MM-DD) → parse components locally to avoid UTC shift
    if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) {
      const [y, m, d] = iso.split("-").map(Number);
      return new Date(y, m - 1, d).toLocaleDateString("es-EC", { day: "2-digit", month: "short", year: "numeric" });
    }
    return new Date(iso).toLocaleDateString("es-EC", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
}

export function daysUntil(dueDate) {
  if (!dueDate) return null;
  const today = new Date(); today.setHours(0,0,0,0);
  let d;
  if (/^\d{4}-\d{2}-\d{2}$/.test(dueDate)) {
    const [y, m, dd] = dueDate.split("-").map(Number);
    d = new Date(y, m - 1, dd);
  } else {
    d = new Date(dueDate);
  }
  d.setHours(0,0,0,0);
  return Math.round((d - today) / (1000*60*60*24));
}

export function initials(name) {
  if (!name) return "?";
  return name.split(" ").filter(Boolean).slice(0,2).map(s => s[0].toUpperCase()).join("");
}
